import { render, staticRenderFns } from "./GalleryShare.vue?vue&type=template&id=6088e132&scoped=true&"
import script from "./GalleryShare.vue?vue&type=script&lang=js&"
export * from "./GalleryShare.vue?vue&type=script&lang=js&"
import style0 from "./GalleryShare.vue?vue&type=style&index=0&id=6088e132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6088e132",
  null
  
)

export default component.exports